// const dbName = 'fileUploadDB';
// const storeName = 'uploadedChunks';

const myDB = {
    dbName: 'fileUploadDB',
    storeName: 'uploadedChunks',
    db: null
};
function openDB(keyPath) {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(myDB.dbName, 1);

        request.onupgradeneeded = function (event) {
            // const db = event.target.result;
            myDB.db = event.target.result;
            myDB.db.createObjectStore(myDB.storeName, { keyPath: keyPath });// 创建一个对象仓库
        };

        request.onsuccess = function (event) {
            myDB.db = event.target.result;
            resolve(event.target.result);
        };

        request.onerror = function (event) {
            reject(event.target.error);
        };
    });
}

function saveUploadedChunks(db, uploadedChunks) {
    const transaction = myDB.db.transaction([myDB.storeName], 'readwrite');
    const objectStore = transaction.objectStore(myDB.storeName);
    const request = objectStore.put(uploadedChunks);

    request.onsuccess = function () {
        console.log('Uploaded chunks saved successfully');
    };

    request.onerror = function (event) {
        console.error('Error saving uploaded chunks', event.target.error);
    };
}

function getUploadedChunks(db, fileName) {
    return new Promise((resolve, reject) => {
        const transaction = myDB.db.transaction([myDB.storeName], 'readonly');
        const objectStore = transaction.objectStore(myDB.storeName);
        const request = objectStore.get(fileName);

        request.onsuccess = function (event) {
            const result = event.target.result;
            if (result) {
                resolve(result);
            } else {
                resolve(null);
            }
        };

        request.onerror = function (event) {
            reject(event.target.error);
        };
    });
}

function deleteAllData(id) {
    if (!myDB.db) {
        return
    }
    var transaction = myDB.db.transaction(myDB.storeName, 'readwrite');
    var objectStore = transaction.objectStore(myDB.storeName);
    let keyRange = IDBKeyRange.bound(id, id + '\uffff');
    let request = objectStore.openCursor(keyRange);
    let results = []; // 用于存储结果的数组
    request.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
            results.push(cursor.key); // 将每个符合条件的记录添加到数组中
            cursor.continue();
        } else {
            console.log(results);
            for (let i = 0; i < results.length; i++) {
                deleteData(results[i]);
            }
        }
    };
    request.onerror = function (event) {
        console.error('Error opening cursor: ' + event.target.errorCode);
    };

}

function deleteData(id) {
    var transaction = myDB.db.transaction(myDB.storeName, 'readwrite');
    var table1 = transaction.objectStore(myDB.storeName);

    var request = table1.delete(id);
    request.onsuccess = function (event) {
        console.log('数据成功删除');
        console.log(request)
    };
}

function closeDB() {//关闭
    myDB.db.close();
}
function deleteDB() {//删除
    indexedDB.deleteDatabase(myDB.dbName);//删除数据库
}
export { openDB, saveUploadedChunks, getUploadedChunks, closeDB, deleteDB, deleteData, deleteAllData };